var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucessTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_31578_12850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 33.8036,
    stroke: "#50FB80",
    strokeWidth: 2.60714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_31578_12850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.4997,
    cy: 35.4997,
    r: 27.8571,
    fill: "#03AF30"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.236 28.5503C45.1012 28.4143 44.9407 28.3063 44.7639 28.2327C44.5871 28.159 44.3975 28.1211 44.2059 28.1211C44.0144 28.1211 43.8247 28.159 43.6479 28.2327C43.4711 28.3063 43.3107 28.4143 43.1758 28.5503L32.3666 39.3739L27.8253 34.8181C27.6853 34.6828 27.52 34.5765 27.3388 34.5051C27.1577 34.4337 26.9642 34.3987 26.7696 34.4021C26.5749 34.4054 26.3828 34.4471 26.2042 34.5247C26.0256 34.6023 25.8641 34.7144 25.7288 34.8544C25.5935 34.9944 25.4871 35.1598 25.4158 35.3409C25.3444 35.5221 25.3094 35.7155 25.3127 35.9102C25.3161 36.1049 25.3578 36.297 25.4354 36.4755C25.513 36.6541 25.625 36.8157 25.7651 36.9509L31.3365 42.5224C31.4714 42.6584 31.6318 42.7663 31.8087 42.84C31.9855 42.9136 32.1751 42.9515 32.3666 42.9515C32.5582 42.9515 32.7478 42.9136 32.9246 42.84C33.1014 42.7663 33.2619 42.6584 33.3968 42.5224L45.236 30.6831C45.3833 30.5472 45.5009 30.3823 45.5812 30.1988C45.6616 30.0152 45.7031 29.817 45.7031 29.6167C45.7031 29.4163 45.6616 29.2181 45.5812 29.0346C45.5009 28.851 45.3833 28.6861 45.236 28.5503Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_31578_12850",
    x: -111.342,
    y: -111.342,
    width: 293.684,
    height: 293.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.8673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_31578_12850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_31578_12850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_31578_12850",
    x: -104.092,
    y: -104.092,
    width: 279.183,
    height: 279.184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.8673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_31578_12850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_31578_12850",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessTwo);
export default __webpack_public_path__ + "static/media/sucess-two.291a3e6cacaabd5e7f2916e276dece72.svg";
export { ForwardRef as ReactComponent };